import { useDispatch, useSelector } from "react-redux";
import cms from "../../../constants/cmskeys";
import cmsParser from "../../Services/CMSParser";
import {
  changeEmail,
  changeIsCheckedEmail,
} from "../../../redux/Slices/EmailSlice";

const Email = ({ cmsLabels }) => {
  const { isCheckedEmail, email } = useSelector((state) => state.email);
  const dispatch = useDispatch();

  return (
    <div className="dds__py-2 dds__border-top">
      <div className="dds__checkbox" role="checkbox">
        <label className="dds__checkbox__label dds__w-100" htmlFor="lrEmailCheck">
          <input
            className="dds__checkbox__input"
            type="checkbox"
            name="lrEmailCheck"
            id="lrEmailCheck"
            value="lg"
            onChange={() => dispatch(changeIsCheckedEmail(!isCheckedEmail))}
          />
          <span tabIndex="-1">{cmsParser(cms.Email, cmsLabels)}</span>
        </label>
      </div>
      <div
        className={
          "dds__py-4 dds__px-5 dds__d-none " +
          (isCheckedEmail ? "dds__d-block" : "dds__d-none")
        }
      >
        <div className="dds__row">
          <div className="dds__col--lg-8 dds__col--xl-6">
            <div className="dds__input-text__container dds__row dds__align-items-center">
              <div className="dds__col--md-4 dds__text-md-right">
                <label
                  id="lblLREmail"
                  htmlFor="txtLREmail"
                  className="required-field"
                >
                  {cmsParser(cms.Email_Address, cmsLabels)}{" "}
                </label>
              </div>

              <div className="dds__col--md-8">
                <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                  <input
                    type="email"
                    className="dds__input-text"
                    maxLength="360"
                    name="txtLREmail"
                    id="txtLREmail"
                    aria-labelledby="lblLREmail"
                    onChange={(e) => dispatch(changeEmail(e.target.value))}
                    value={email}
                  />
                  <div
                    id="email-input-feedback"
                    className="dds__invalid-feedback"
                  >
                    {cmsParser(cms.validate_email,cmsLabels)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Email;
